export default {
  state: {
    orderProducts: [],
  },
  mutations: {
    addProduct(state, payload) {
      // Check if the product already exists in the order
      const existingProductIndex = state.orderProducts.findIndex(product => product.id === payload.id);
      if (existingProductIndex !== -1) {
        // If it exists, increment the amount
        state.orderProducts[existingProductIndex].amount++;
        return;
      }
      const productToAdd = {
        ...payload,
        amount: payload.amount || 1,
      };
      state.orderProducts.push(productToAdd);
    },
    removeProduct(state, payload) {
      state.orderProducts = state.orderProducts.filter(product => product.id !== payload.id);
    },
    clearOrder(state) {
      state.orderProducts = [];
    },
    decreaseProductAmount(state, payload) {
      const product = state.orderProducts.find(product => product.id === payload.id);
      if (product && product.amount > 1) {
        product.amount--;
      } else {
        state.orderProducts = state.orderProducts.filter(product => product.id !== payload.id);
      }
    },
    increaseProductAmount(state, payload) {
      const product = state.orderProducts.find(product => product.id === payload.id);
      if (product) {
        product.amount++;
      }
    }
  },
  actions: {
    addProduct(context, payload) {
      context.commit('addProduct', payload);
      context.dispatch('showSuccessSnack', `Produto ${payload.name} adicionado ao carrinho!`);
    },
    removeProduct(context, payload) {
      context.commit('removeProduct', payload);
      context.dispatch('showSuccessSnack', `Produto ${payload.name} removido do carrinho!`);
    },
    clearOrder(context) {
      context.commit('clearOrder');
      context.dispatch('showSuccessSnack', 'Carrinho limpo com sucesso!');
    },
    decreaseProductAmount(context, payload) {
      context.commit('decreaseProductAmount', payload);
      context.dispatch('showSuccessSnack', `Quantidade do produto ${payload.name} diminuída!`);
    },
    increaseProductAmount(context, payload) {
      context.commit('increaseProductAmount', payload);
      context.dispatch('showSuccessSnack', `Quantidade do produto ${payload.name} aumentada!`);
    },
  },
  getters: {
    getOrderProducts(state) {
      return state.orderProducts;
    },
    getCartCount(state) {
      return state.orderProducts.length;
    }
  },
}